const CLIENT_BASE_PATH = "/customers";

export const createClientUrl = () => CLIENT_BASE_PATH;

export const listClientPortfoliosUrl = () => `${CLIENT_BASE_PATH}/list`;
